/**
 * Compact, contextual reference to MaintenanceSpec. Rendered only where the
 * reader is already in maintenance context and a published schedule exists.
 */
interface Props {
  heading: string;
  body: React.ReactNode;
  anchor: string;
  href: string;
}

export function MaintenanceSpecLink({ heading, body, anchor, href }: Props) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <h2 className="text-base font-semibold text-foreground">{heading}</h2>
      <p className="mt-1 text-sm text-muted-foreground leading-relaxed">{body}</p>
      <a
        href={href}
        className="mt-2 inline-block text-sm font-medium text-primary hover:underline"
      >
        {anchor}
      </a>
    </div>
  );
}
